import wpTooltip from '@/components/ui/tooltip/wpTooltip';
import clickOutside from '@/directives/clickOutside';
import noTranslate from '@/directives/noTranslate';
import stickyDirective from '@/directives/sticky';

// register all directives
const directives = (app) => {
  clickOutside(app);
  stickyDirective(app);
  noTranslate(app);
  wpTooltip(app);
};

export default directives;
